import React from 'react';
import * as Styled from './style';
import AgentImage from '../../assets/images/chat-agent.png';
import CheckIcon from '../../assets/images/check-icon.png';

export default function HelpSection() {


  const handleScroll = () => {
    const formSection = document.getElementById('demo-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Styled.Section>
      <Styled.Left>
        <Styled.Container>
          <Styled.Heading>Not a coder? No problem</Styled.Heading>
          <Styled.Text>
            We’re not just providing a chatbot. We’re providing a team of
            implementers, support staff, and specialists to help turn your
            website into a lead-capturing machine. You’ll gain access to:
          </Styled.Text>
          <Styled.List>
            <li>
              <img src={CheckIcon} alt='check icon' />
              White-glove onboarding
            </li>
            <li>
              <img src={CheckIcon} alt='check icon' />
              Training and customization based on your business
            </li>
            <li>
              <img src={CheckIcon} alt='check icon' />
              24/7 support from our team
            </li>
          </Styled.List>
          <Styled.Text>
            The best part? We’ll set everything up ourselves so you don’t have
            to lift a finger.
          </Styled.Text>

          <Styled.Button onClick={handleScroll}>Get a demo</Styled.Button>

        </Styled.Container>
      </Styled.Left>

      <Styled.Right>
        <Styled.Image src={AgentImage} alt='Support agent' />
      </Styled.Right>
    </Styled.Section>
  );
}
